export default {
  API_ENDPOINT: "https://thawing-mesa-40257.herokuapp.com/api",
  TOKEN_KEY: "token-memegram-api"
};
